/** Resolve an entered wall-clock time in an explicit IANA timezone. */
export function scheduledInstant(
  date: string,
  time: string,
  timezone: string,
): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  const clock = /^(\d{2}):(\d{2})$/.exec(time);
  if (!match || !clock || !timezone.trim())
    throw new Error('Informe data, hora e fuso horário para o agendamento.');
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const hour = Number(clock[1]);
  const minute = Number(clock[2]);
  if (
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31 ||
    hour > 23 ||
    minute > 59
  )
    throw new Error('A data ou a hora informada é inválida.');
  let formatter: Intl.DateTimeFormat;
  try {
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    });
  } catch {
    throw new Error(
      'Fuso horário inválido. Use um nome IANA, como America/Sao_Paulo.',
    );
  }
  const wallTime = `${date} ${time}`;
  const naiveUtc = Date.UTC(year, month - 1, day, hour, minute);
  const matches: number[] = [];
  for (
    let offsetMinutes = -14 * 60;
    offsetMinutes <= 14 * 60;
    offsetMinutes += 15
  ) {
    const candidate = naiveUtc - offsetMinutes * 60_000;
    const values = Object.fromEntries(
      formatter.formatToParts(candidate).map((part) => [part.type, part.value]),
    );
    if (
      `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}` ===
      wallTime
    )
      matches.push(candidate);
  }
  if (matches.length !== 1)
    throw new Error(
      matches.length === 0
        ? 'Este horário não existe nesse fuso. Escolha outro horário.'
        : 'Este horário ocorre duas vezes nesse fuso. Escolha outro horário.',
    );
  return new Date(matches[0]!).toISOString();
}
